/**
 * Created by Michal on 14.09.2016.
 */
// import '../../scss/layout/_footer.scss';

import 'slick-carousel';

$(document).ready(function() {

    console.log('LOADED: footer');

    const $opp = $('.foot-opp .foot-slider');
    const $partners = $('.foot-partners .foot-slider');

    const config = {
        dots: true,
        arrows: true,
        slidesToShow: 7,
        slidesToScroll: 7,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: '<button type="button" class="slick-prev icon-arrow-alt-circle-left"></button>',
        nextArrow: '<button type="button" class="slick-next icon-arrow-alt-circle-right"></button>',

        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            }, {
                breakpoint: 767,
                settings: {
                    dots: false,
                    arrows: false,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            }, {
                breakpoint: 560,
                settings: {
                    dots: false,
                    arrows: false,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            }
        ],
    };

    $opp.slick({
        ...config,
        appendDots: $opp.next('.foot-slider-footer').children('div'),
        appendArrows: $opp.next('.foot-slider-footer').children('div'),
    });

    $partners.slick({
        ...config,
        appendDots: $partners.next('.foot-slider-footer').children('div'),
        appendArrows: $partners.next('.foot-slider-footer').children('div'),
    });

});
